export const MIDNIGHT_BLUE = '#012169';
export const WHITE = '#FFFFFF';
export const ATHENS_GRAY = '#EAECF1';
export const CERULEAN = '#00A3E0';
